/* eslint-disable max-len */
import 'react';
const AddCircleSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        <g id="星标支持添加分组" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="画板备份" transform="translate(-58.000000, -1519.000000)" stroke="#3377FF">
                <g id="编组-25备份-5" transform="translate(44.000000, 1304.000000)">
                    <g id="编组-36" transform="translate(14.000000, 205.000000)">
                        <g id="编组-28" transform="translate(0.000000, 6.000000)">
                            <g id="编组-30" transform="translate(0.000000, 4.000000)">
                                <path d="M3,6 L9,6 M6,3 L6,9" id="形状结合" strokeLinecap="round"></path>
                                <circle id="椭圆形" cx="6" cy="6" r="5.5"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default AddCircleSvg;
